export const SET_TRANSPORT_PROPERTY = 'SET_TRANSPORT_PROPERTY';
export const TRANSPORT_GET_MASTER_DATA = 'TRANSPORT_GET_MASTER_DATA';
export const TRANSPORT_UPDATE_MASTER_DATA = 'TRANSPORT_UPDATE_MASTER_DATA';
export const TRANSPORT_RESET_FILTERS = 'TRANSPORT_RESET_FILTERS';
export const TRANSPORT_GET_LIST = 'TRANSPORT_GET_LIST';
export const TRANSPORT_EMPLOYEES_GET_LIST = 'TRANSPORT_EMPLOYEES_GET_LIST';
export const TRANSPORT_GET_DRIVERS = 'TRANSPORT_GET_DRIVERS';
export const TRANSPORT_SET_DRIVER = 'TRANSPORT_SET_DRIVER';
export const TRANSPORT_RESET_EMPLOYEES_FILTERS = 'TRANSPORT_RESET_EMPLOYEES_FILTERS';
export const TRANSPORT_RESET_DRIVER_FILTERS = 'TRANSPORT_RESET_DRIVER_FILTERS';
export const TRANSPORT_LOGISTIC_DRIVER_GET_LIST = 'TRANSPORT_LOGISTIC_DRIVER_GET_LIST';
export const TRANSPORT_GET_ACT = 'TRANSPORT_GET_ACT';
export const TRANSPORT_ACCEPT = 'TRANSPORT_ACCEPT';
export const TRANSPORT_DENY = 'TRANSPORT_DENY';
export const TRANSPORT_REJECT = 'TRANSPORT_REJECT';
export const CANCEL_MANAGEMENT = 'CANCEL_MANAGEMENT';
export const SET_ACT_CHECKLIST_INTERIOR_ACCESSORIES = 'SET_ACT_CHECKLIST_INTERIOR_ACCESSORIES';
export const SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM = 'SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM';
export const DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM =
  'DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM';
export const SET_ACT_CHECKLIST_INTERIOR_BREAKS_ITEM = 'SET_ACT_CHECKLIST_INTERIOR_BREAKS_ITEM';
export const EDIT_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM = 'EDIT_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM';
export const SET_ACT_CHECKLIST_EXTERIOR_ACCESSORIES = 'SET_ACT_CHECKLIST_EXTERIOR_ACCESSORIES';
export const ACT_RESET_DATA_TO_SEND = 'ACT_RESET_DATA_TO_SEND';
export const ACT_SAVE_DATA_TRANSFER = 'ACT_SAVE_DATA_TRANSFER';
export const ACT_SAVE_DATA = 'ACT_SAVE_DATA';
export const GET_REQUIRED_DOCUMENTATION = 'GET_REQUIRED_DOCUMENTATION';
export const UI_UPDATE_FROM_PARTNER = 'UI_UPDATE_FROM_PARTNER';
export const VALIDATE_DOCUMENT = 'VALIDATE_DOCUMENT';
export const CANCEL_ACT = 'CANCEL_ACT';
export const CANCEL_ACT_TRANSFER = 'CANCEL_ACT_TRANSFER';
export const TRANSPORT_ACT_RESET_TIRES = 'TRANSPORT_ACT_RESET_TIRES';
export const GET_REQUIRED_DOCUMENTATION_OFFLINE = 'GET_REQUIRED_DOCUMENTATION_OFFLINE';
export const GET_REQUIRED_IMAGES_OFFLINE = 'GET_REQUIRED_IMAGES_OFFLINE';
export const UPDATE_RISK_OFFLINE = 'UPDATE_RISK_OFFLINE';
export const GET_ID_TRANSACTION_OFFLINE = 'GET_ID_TRANSACTION_OFFLINE';
export const SAVE_DOCUMENTS_OFFLINE = 'SAVE_DOCUMENTS_OFFLINE';
export const GET_OFFLINE_PRINT = 'GET_OFFLINE_PRINT';
